export default __webpack_public_path__ + "static/media/bussiness_leader_icon.c6b22a79.png";